module.exports = __webpack_public_path__ + "static/media/S23-0167_2.99_Mama_Burger_Website_Desktop_2396x1473.794c6cad.jpg";